import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface InitialStateProps {
  selectedProjectShortName: string | null | undefined;
}

const localStorageKeyName = 'selectedProjectShortName';
const initialState: InitialStateProps = {
  selectedProjectShortName: localStorage.getItem(localStorageKeyName) ? localStorage.getItem(localStorageKeyName) : undefined
};

const projectFilterSlice = createSlice({
  name: 'projectFilter',
  initialState,
  reducers: {
    setSelectedProjectShortName: (state, action: PayloadAction<string | null | undefined>) => {
      state.selectedProjectShortName = action.payload;
      action.payload && localStorage.setItem(localStorageKeyName, action.payload);
    },

    resetSelectedProjectShortName: (state) => {
      state.selectedProjectShortName = undefined;
      localStorage.removeItem(localStorageKeyName);
    }
  }
});

export const { setSelectedProjectShortName, resetSelectedProjectShortName } = projectFilterSlice.actions;
export default projectFilterSlice.reducer;
